import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";

import './Layout.css';
import MainHeader from '../MainHeader';
import MainSidebar from '../MainSidebar';

const Layout = props => (
    <div className="layout">
        <Helmet>
            <title>{props.title}</title>
        </Helmet>
        <MainHeader signOut={props.signOut} user={props.user}/>
        <MainSidebar user={props.user}/>
        <main className="page content-wrapper">
            {props.children}
        </main>
    </div>
);

Layout.propTypes = {
    signOut: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    user: PropTypes.object
};

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/index.js